export const discountDraft = (row) => ({
  discountCode: row?.discountCode ?? "",
  name: row?.name ?? "",
  type: row?.type ?? "percentage",
  discount: row?.discount ?? "",
  useLimit: row?.useLimit ?? "",
  customerUseLimit: row?.customerUseLimit ?? "",
  minPurchaseValue: row?.minPurchaseValue ?? "",
  isCumulative: row?.isCumulative === true || row?.isCumulative === 1,
  initDate: row?.initDate
    ? new Date(row.initDate).toISOString().slice(0, 10)
    : "",
  finalDate: row?.finalDate
    ? new Date(row.finalDate).toISOString().slice(0, 10)
    : "",
  initTime: row?.initDate
    ? new Date(row.initDate).toISOString().slice(11, 19)
    : "00:00:00",
  finalTime: row?.finalDate
    ? new Date(row.finalDate).toISOString().slice(11, 19)
    : "23:59:59",
});
const numeric = (value) => (value === "" ? null : Number(value));
export const discountPayload = (form, row) => {
  if (!form.discountCode.trim())
    throw Error("Escribe el código del descuento.");
  if (!["percentage", "value"].includes(form.type))
    throw Error("Este tipo de descuento no se puede editar.");
  const discount = Number(form.discount);
  if (
    form.discount === "" ||
    !Number.isInteger(discount) ||
    discount <= 0 ||
    (form.type === "percentage" && discount > 100)
  )
    throw Error(
      "El valor debe ser un entero positivo; el porcentaje no puede superar 100.",
    );
  for (const key of ["useLimit", "customerUseLimit", "minPurchaseValue"])
    if (
      form[key] !== "" &&
      (!Number.isInteger(Number(form[key])) || Number(form[key]) < 0)
    )
      throw Error(
        "Los límites y la compra mínima deben ser enteros positivos o cero.",
      );
  const original = row ? discountDraft(row) : null;
  const timestamp = (key, time) => {
    if (
      original &&
      form[key] === original[key] &&
      form[time] === original[time]
    )
      return row[key];
    if (!form[key]) return null;
    const value = new Date(`${form[key]}T${form[time]}Z`);
    if (!Number.isFinite(value.getTime()))
      throw Error("Revisa las fechas y horas de vigencia.");
    return value.toISOString();
  };
  const initDate = timestamp("initDate", "initTime"),
    finalDate = timestamp("finalDate", "finalTime");
  if ((!initDate || !finalDate) && !row)
    throw Error("Selecciona las dos fechas de vigencia.");
  if ((!initDate && row?.initDate) || (!finalDate && row?.finalDate))
    throw Error("Las fechas existentes no se pueden dejar vacías.");
  if (initDate && finalDate && Date.parse(finalDate) <= Date.parse(initDate))
    throw Error("La fecha final debe ser posterior al inicio.");
  return {
    name: form.name.trim() || form.discountCode.trim(),
    discountCode: form.discountCode.trim(),
    type: form.type,
    discount,
    applicableTo: row?.applicableTo ?? "order",
    initDate,
    finalDate,
    isCumulative: form.isCumulative,
    useLimit: numeric(form.useLimit),
    customerUseLimit: numeric(form.customerUseLimit),
    minPurchaseValue: numeric(form.minPurchaseValue),
  };
};
export const discountMatches = (row, expected) =>
  Object.entries(expected).every(([key, value]) => {
    if (key === "initDate" || key === "finalDate")
      return value == null
        ? row[key] == null
        : Date.parse(row[key]) === Date.parse(value);
    if (
      ["discount", "useLimit", "customerUseLimit", "minPurchaseValue"].includes(
        key,
      )
    )
      return value == null ? row[key] == null : Number(row[key]) === value;
    if (key === "isCumulative")
      return (row[key] === true || row[key] === 1) === value;
    return row[key] === value;
  });
